import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** Утилиты новой дизайн-системы идут с префиксом `nd:` (см. newdesign.css). */
const twMerge = extendTailwindMerge({ prefix: 'nd' });

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
